import { render, staticRenderFns } from "./EditCorridorAwareness.vue?vue&type=template&id=424bf45c&scoped=true&"
import script from "./EditCorridorAwareness.vue?vue&type=script&lang=js&"
export * from "./EditCorridorAwareness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424bf45c",
  null
  
)

export default component.exports